const stripTrailingSlash = (value: string) => value.replace(/\/+$/, '');

export const ENGINE_API_BASE_URL = stripTrailingSlash(
  process.env.REACT_APP_ENGINE_API_BASE_URL
    || 'https://genai-eapi-beta-genai-eime-beta-ujzctvhsxv.cn-hangzhou.fcapp.run'
);

export const MAIN_BASE_URL = stripTrailingSlash(
  process.env.REACT_APP_MAIN_URL || 'https://craftcloud.top'
);

export const PM_BASE_URL = stripTrailingSlash(
  process.env.REACT_APP_PM_URL || 'https://pm.craftcloud.top'
);

export const isProductionBrowser = process.env.NODE_ENV === 'production';

